import { InflatedListItemProduct } from './ListTypes'
import React from 'react'

export default function ProductLedTag(props: { configuredProduct: InflatedListItemProduct }) {
  const { ledEnabled, configuredButtons } = props.configuredProduct

  return ledEnabled && configuredButtons.find(it => it.mechProduct?.supportsLed) ? (
    <>
      <br/>
      <span className="ProductLedTag">LED</span>
    </>
  ) : null
}
